<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records cart-section">
            <div class="row h-100">
                <div class="col-12 mb-4">
                    <div class="bg-white border-radius-5 p-4">
                        <div class="card border-0">
                            <div class="card-header border-0 bg-white p-0">
                                <h2>Cart</h2>
                            </div>
                            <div class="card-body p-0">
                                <div class="table-responsive">
                                    <table class="table cart-table" border="0" cellspacing="0" cellpadding="0">
                                        <tr>
                                            <td class="product-image">
                                                <figure class="mb-0"><img src="../../../../static/website/images/prescription-cart.png" /></figure>
                                            </td>
                                            <td class="product-name">
                                                <h2>Gini DNA Kit</h2>
                                                <p>Decode your gene-health- nutrition relationship</p>
                                            </td>

                                            <td class="cart">$45.95</td>
                                            <td class="icon"><i class="icon icon-close"></i></td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="row justify-content-between Order-Summary mt-5">
                                    <div class="col-md-5 coupon">
                                        <h3>Coupon</h3>
                                        <form class="form coupon-code position-relative border-radius-8 px-3 py-2 bg-body align-items-center justify-content-between d-flex">
                                            <input type="text" name="text" placeholder="Enter your coupon code" />
                                            <button type="text" class="btn btn-blue apply">Apply</button>
                                        </form>
                                    </div>
                                    <div class="col-md-4">
                                        <h3>Order Summary</h3>
                                        <ul class="cart-table mb-0 bg-body border-radius-8">
                                            <li class="d-flex justify-content-between border-bottom">
                                                <p class="mb-0">Complete</p>
                                                <p class="mb-0">$45.00</p>
                                            </li>
                                            <li class="d-flex justify-content-between border-bottom">
                                                <p class="mb-0">Discount</p>
                                                <p class="mb-0">-$10.00</p>
                                            </li>
                                            <li class="d-flex justify-content-between">
                                                <p class="mb-0">Total</p>
                                                <p class="mb-0">$35.00</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end mt-5 mb-4"><router-link to="/checkout" class="btn btn-blue Proceed-checkout">Proceed to checkout</router-link></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "prescription-cart",
        data() {
            return {};
        },
        created(){
           this.pageName('Cart')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/prescription-cart.vue